import { render, staticRenderFns } from "./AccreditationMasterApprove.vue?vue&type=template&id=e796b6e0&"
import script from "./AccreditationMasterApprove.vue?vue&type=script&lang=js&"
export * from "./AccreditationMasterApprove.vue?vue&type=script&lang=js&"
import style0 from "./AccreditationMasterApprove.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports